import React from "react";
import {
  Box,
  Typography,
  Paper,
  IconButton,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const ChatTemplates = ({ onTemplateSelect, isOpen, onToggle }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const templates = [
    {
      title: "Tell me more about my Career Report",
      prompt: "Tell me more about my Career Report",
    },
    {
      title: "What Career Animal am I?",
      prompt: "Tell more about my career animal",
    },
    {
      title: "What's my career direction?",
      prompt: "What's my career direction?",
    },
    {
      title: "How can I improve my career health?",
      prompt: "Give me some ideas on how can I improve my career health?",
    },
    {
      title: "What could make me happier at work? (what are my dissatisfiers)",
      prompt: "What could make me happier at work? (what are my dissatisfiers)",
    },
    {
      title: "How do I progress my career?",
      prompt: "Give me suggestion on how do I progress my career?",
    },
    {
      title: "What skills should I enhance?",
      prompt: "What skills should I enhance?",
    },
  ];

  // Define gradient backgrounds for templates
  const gradients = [
    "linear-gradient(135deg, #E8F5E9 0%, #C8E6C9 100%)", // Light green gradient
    "linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%)", // Light blue gradient
    "linear-gradient(135deg, #F3E5F5 0%, #E1BEE7 100%)", // Light purple gradient
    "linear-gradient(135deg, #FFF3E0 0%, #FFE0B2 100%)", // Light orange gradient
    "linear-gradient(135deg, #E1F5FE 0%, #B3E5FC 100%)", // Light cyan gradient
    "linear-gradient(135deg, #F1F8E9 0%, #DCEDC8 100%)", // Light lime gradient
    "linear-gradient(135deg, #E8EAF6 0%, #C5CAE9 100%)", // Light indigo gradient
  ];

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          p: 2,
          borderBottom: 1,
          borderColor: "divider",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h6">Ideas 🚀</Typography>
        <IconButton onClick={onToggle}>
          <ChevronRightIcon />
        </IconButton>
      </Box>
      <Box sx={{ p: 2, overflow: "auto", flexGrow: 1 }}>
        {templates.map((template, index) => (
          <Paper
            key={index}
            elevation={1}
            sx={{
              p: 2,
              mb: 2,
              cursor: "pointer",
              background: gradients[index % gradients.length],
              transition: "transform 0.2s ease, box-shadow 0.2s ease",
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: 3,
              },
            }}
            onClick={() => onTemplateSelect(template.prompt)}
          >
            <Typography
              variant="subtitle1"
              fontWeight="bold"
              sx={{ color: "rgba(0, 0, 0, 0.87)" }}
            >
              {template.title}
            </Typography>
            {template.description && (
              <Typography variant="body2" sx={{ color: "rgba(0, 0, 0, 0.6)" }}>
                {template.description}
              </Typography>
            )}
          </Paper>
        ))}
      </Box>
    </Box>
  );
};

export default ChatTemplates;
